import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">专题精选</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            深度策划的娱乐专题内容，不一样的吃瓜视角
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {carouselData.map((item) => (
            <article key={item.id} className="group relative bg-foreground-900 rounded-xl overflow-hidden cursor-pointer h-[320px] md:h-[360px]">
              <div className="absolute inset-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900 via-foreground-900/50 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <span className="px-2.5 py-1 rounded-full text-[10px] font-semibold bg-primary-500 text-background-50 whitespace-nowrap self-start mb-3">
                  {item.category}
                </span>
                <h3 className="font-heading font-bold text-lg md:text-xl text-background-50 mb-2 group-hover:text-primary-300 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-300 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}